var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:_vm.type,style:({'color': _vm.color,
'font-size': _vm.size + 'px',
'margin-right': _vm.right + 'px',
'margin-left': _vm.left + 'px',
 'font-weight': _vm.bold ? '600':'500',
 'line-height': _vm.lineHeight}),on:{"click":_vm.onClick}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4205c628","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/admin/components/commonComponents/psimFontIcon.vue
// module id = null
// module chunks = 